import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'reactstrap'

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError = error => {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error }
  }

  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch = (error, info) => {
    this.setState({ error: error, info: info })
  }

  render() {
    const { hasError, error, info } = this.state
    const {
      color = 'danger',
      message = 'There was a problem with your request.',
    } = this.props
    if (hasError) {
      return (
        <div className="container">
          <Alert color={color}>
            {message}
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {error && error.toString()}
              <br />
              {info && info.componentStack}
            </details>
          </Alert>
        </div>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  message: PropTypes.string,
}

export default ErrorBoundary
